import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter } from 'react-router-dom';

import 'src/store/init';
import 'src/ui/theme/index.css';
import { historyRef } from 'src/history';
import { App } from 'src/app';
import { reportWebVitals } from 'src/common/report-web-vitals';

ReactDOM.render(
	<BrowserRouter>
		<Route>
			{({ history }) => {
				historyRef.current = history;

				return (
					<App/>
				);
			}}
		</Route>
	</BrowserRouter>,
	document.getElementById('root'),
);

reportWebVitals();
